import React from "react"

import CollectionSidebar from "../components/collectionSidebar"
import ProductGrid from "../components/productGrid"

class CollectionHolder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagFilters: [],
      typeFilter: null,
      personalizationFilter: null,
      otherFilter: null,
      occasionFilter: null,
      count: 12,
    }
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleCountChange = this.handleCountChange.bind(this);
  }

  handleTypeChange(name, value) {
    this.setState({
      [name]: value,
    })
  }

  handleCountChange(e) {
    this.setState({
      count: this.state.count + 12
    });
  }

  filterCollection() {
    // Re-filter the collection using the array of filters (or just the latest?)
    // return the filtered collection

    const collection = this.props.collection.products
    const count = this.state.count

    if (this.state.typeFilter) {
      //.filter(n => n.tags.includes(`${filterToUse}`) && n.tags.includes("Labeled"))
      const filteredCollection = collection
        .filter(n => n.tags.includes(this.state.typeFilter))
        .slice(0, count);
      return filteredCollection;
    } else {
      const filteredCollection = collection
        .slice(0, count);
      return filteredCollection;
    }
  }

  render () {
    return (
      <div className="columns m-0 py-4">
        {/* sidebar */}
        <CollectionSidebar
          onFilterChange={this.handleTypeChange}
          typeFilter={this.state.typeFilter}
          personalizationFilter={this.state.personalizationFilter}
          otherFilter={this.state.otherFilter}
          occasionFilter={this.state.occasionFilter}
          collectionTags={this.props.collectionTags}
        />

        {/* product grid */}
        <ProductGrid
          onCountChange={this.handleCountChange}
          handle={this.props.collection.handle}
          collection={this.filterCollection()}
        />
      </div>
    )
  }
}

export default CollectionHolder